import React from 'react'

function Footer() {
    return (
        <footer className="textCenter textWhite">
            <div className="wrapper">
                <p></p>
                <p className="textSmall">Copyright &copy; {new Date().getFullYear()} Sahashra Rajbhandari</p>
            </div>
        </footer>
    )
}

export default Footer
